import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export const RadioEmoji = ({
  field: { name, value, ...field },
  id,
  rating,
  emoji,
  description,
}) => (
  <div>
    <Input
      type="radio"
      name={name}
      id={id}
      value={rating}
      checked={value === rating}
      {...field}
    />
    <Label htmlFor={id}>
      <img src={emoji} alt={description} />
    </Label>
  </div>
);

RadioEmoji.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  id: PropTypes.string.isRequired,
  rating: PropTypes.string.isRequired,
  emoji: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default RadioEmoji;

const Input = styled.input`
  display: none;
`;

const Label = styled.label`
  display: inline-block;
  flex: 1;
  padding: 5px;
  opacity: 0.5;
  transform: scale(0.7);
  cursor: pointer;
  text-align: center;
  transition: transform 0.33s ease-out, opacity 0.25s ease-out;

  input:checked + & {
    opacity: 1;
    transform: scale(1);
    transition: transform 0.33s cubic-bezier(0.65, -0, 0.45, 1.75);
  }

  input:not(:checked) + &:hover {
    opacity: 1;
  }

  input:not(:checked) + &:active {
    transform: scale(0.6);
  }

  img {
    width: 96px;
    height: 96px;
  }
`;
